import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/ui-kit/Tips/InfoTooltip';


import { IPostUser } from '@/features/user/store/user.model';

type TPersonalSituationSummary = Pick<IPostUser, 'occupationCategory' | 'personalAssetsRange' | 'monthlyIncomeRange'>;

export function PersonalSituationSummary({
  occupationCategory,
  personalAssetsRange,
  monthlyIncomeRange,
}: TPersonalSituationSummary) {
  const { t } = useTranslation();

  const situationRowData = useMemo(
    () => [
      {
        title: t('pages.dashboard.createUser.form.occupation.label'),
        tooltip: t('pages.dashboard.createUser.form.occupation.tooltip'),
        value: occupationCategory ? t(`pages.dashboard.createUser.form.occupation.options.${occupationCategory}`) : '/',
      },
      {
        title: t('pages.dashboard.createUser.form.personalAssetsEstimated.label'),
        tooltip: t('pages.dashboard.createUser.form.personalAssetsEstimated.tooltip'),
        value: personalAssetsRange
          ? t(`pages.dashboard.createUser.form.personalAssetsEstimated.options.${personalAssetsRange}`)
          : '/',
      },
      {
        title: t('pages.dashboard.createUser.form.netMontlyIncome.label'),
        value: monthlyIncomeRange
          ? t(`pages.dashboard.createUser.form.netMontlyIncome.options.${monthlyIncomeRange}`)
          : '/',
      },
    ],
    [monthlyIncomeRange, occupationCategory, personalAssetsRange, t],
  );

  return (
    <div className="flex flex-col gap-1">
      {situationRowData.map((row, index) => (
        <div key={`situation-item-${index}`} className="typo-body-regular-paragraph flex items-center gap-3">
          <div className="flex items-center gap-2">
            <span className="text-tertiary">{row.title}</span>
            {row.tooltip && <InfoTooltip tooltipInfo={row.tooltip} infoClassName="min-w-[240px]" />}
          </div>
          <span className="text-secondary">{row.value}</span>
        </div>
      ))}
    </div>
  );
}
